var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-bottom": "20px" },
          attrs: { data: _vm.datas2, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "materialItemType",
              align: "center",
              label: "物料属性",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.materialItemType === "01"
                      ? _c("span", [_vm._v("面料")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.materialItemType === "02"
                      ? _c("span", [_vm._v("辅料")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.materialItemType === "03"
                      ? _c("span", [_vm._v("耗材")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.materialItemType === "04"
                      ? _c("span", [_vm._v("里料")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.materialItemType === null
                      ? _c("span", [_vm._v(" - ")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", prop: "materialItem", label: "物料项目" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.materialItem === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.materialItem) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "skuId", label: "物料编码" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.skuId === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.skuId) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "物料图片" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-image", {
                      attrs: {
                        src: _vm._f("picFilter")(scope.row.materialImage, {
                          size: "large",
                        }),
                        "preview-src-list": [scope.row.materialImage],
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "materialName", label: "物料名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.materialName === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.materialName) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "物料颜色" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.materialColor === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.materialColor) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "suggestSupplierName",
              align: "center",
              label: "供应商",
              width: "95",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "supplierName",
              align: "center",
              label: "实际供应商",
              width: "95",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "供应商信息", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(scope.row.supplierDetail) },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "供应商货号", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.supplierMaterialNo === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(
                            " " + _vm._s(scope.row.supplierMaterialNo) + " "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "供应商色号", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.supplierColorNo === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.supplierColorNo) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "",
              align: "center",
              label: "规格/尺寸",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.specificationCode === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(
                            " " + _vm._s(scope.row.specificationCode) + " "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", align: "center", label: "使用部位" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.part === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.part) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "属性信息", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.describeRemark === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", {
                          domProps: {
                            innerHTML: _vm._s(scope.row.describeRemark),
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", align: "center", label: "单件用量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.pieceDosage === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.pieceDosage) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", align: "center", label: "基本单位" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.baseUnit === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.baseUnit) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", align: "center", label: "损耗" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.attritionRate === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.attritionRate) + "% "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", align: "center", label: "实际用量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.actualDosage === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.actualDosage) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", align: "center", label: "利润" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.profit === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.profit) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "",
              align: "center",
              label: "单价（元）",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.basicUnitPrice === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.basicUnitPrice) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "",
              align: "center",
              label: "金额(元)",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.amountMoney === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.amountMoney) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "采购金额", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _c("span", [_vm._v("采购总量（米）:")]),
                      _vm._v(" "),
                      scope.row.purchaseQtySum === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [
                            _vm._v(_vm._s(scope.row.purchaseQtySum)),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v("采购总额（元）:")]),
                      _vm._v(" "),
                      scope.row.purchaseAmount === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [
                            _vm._v(_vm._s(scope.row.purchaseAmount)),
                          ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "采购信息", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _c("span", [_vm._v("采购米数:")]),
                      _vm._v(" "),
                      scope.row.purchaseQty === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [_vm._v(_vm._s(scope.row.purchaseQty))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v("预估件数:")]),
                      _vm._v(" "),
                      scope.row.estimateQty === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [_vm._v(_vm._s(scope.row.estimateQty))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v("订单件数:")]),
                      _vm._v(" "),
                      scope.row.orderQty === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [_vm._v(_vm._s(scope.row.orderQty))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v("差异件数:")]),
                      _vm._v(" "),
                      scope.row.differenceQty === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [_vm._v(_vm._s(scope.row.differenceQty))]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", align: "center", label: "状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.stateName === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.stateName) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "批色结果", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.approveResult === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.approveResult) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }